import React, { useState } from "react";
import axios from "axios";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AuthShell from "../AuthShell";

const ForgetPassword = () => {
  const baseUrl = "https://fedex-delivery-five.vercel.app/api/";
  const { handleSubmit, register, watch } = useForm({ mode: "onBlur" });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();
  const password = watch("password");

  const handleResetPassword = (formData) => {
    setLoading(true);
    axios.post(baseUrl + "auth/reset", { ...formData, resetToken: id })
      .then(() => {
        toast.success("Password changed successfully");
        setTimeout(() => navigate("/auth/login"), 1400);
      })
      .catch(() => toast.error("We could not reset your password. Please try again."))
      .finally(() => setLoading(false));
  };

  return (
    <AuthShell
      variant="reset"
      title="Choose a new password"
      description="Create a new password and confirm it to finish resetting your account."
      footer={<p>Need a new reset link? <Link to="/auth/forget">Start again</Link></p>}
    >
      <form className="auth-form" onSubmit={handleSubmit(handleResetPassword)} noValidate>
        <label className="auth-field" htmlFor="new-password">New password
          <input id="new-password" type="password" autoComplete="new-password" placeholder="Enter a new password" {...register("password", { required: "Password is required" })} />
        </label>
        <label className="auth-field" htmlFor="confirm-new-password">Confirm new password
          <input id="confirm-new-password" type="password" autoComplete="new-password" placeholder="Enter it again" {...register("confirmpassword", { required: "Please confirm your password", validate: (value) => value === password || "Passwords must match" })} />
        </label>
        <button className="auth-submit" type="submit" disabled={loading}>{loading ? "Updating password…" : "Save new password"}<span aria-hidden="true">→</span></button>
      </form>
      <ToastContainer position="top-right" newestOnTop />
    </AuthShell>
  );
};

export default ForgetPassword;
